'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Statuses = exports.Platforms = exports.Periods = exports.Metrics = exports.BaseUrls = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseUrls = exports.BaseUrls = {
    production: 'https://analytics.wixrestaurants.com/v1'
};

var Metrics = exports.Metrics = {
    price: 'price'
};

var Periods = exports.Periods = {
    day: 'day',
    week: 'week',
    month: 'month',
    year: 'year',
    lifetime: 'lifetime',
    hourOfWeek: 'hourOfWeek',
    monthOfYear: 'monthOfYear'
};

var Platforms = exports.Platforms = {
    web: 'web',
    mobileweb: 'mobileweb',
    android: 'android',
    ios: 'ios',
    facebook: 'facebook',
    callcenter: 'callcenter',
    'kiosk.android': 'kiosk.android',
    'kiosk.ios': 'kiosk.ios',
    'com.messenger': 'com.messenger',
    'org.telegram': 'org.telegram',
    'com.slack': 'com.slack'
};

var Statuses = exports.Statuses = {
    pending: 'pending',
    new: 'new',
    accepted: 'accepted',
    canceled: 'canceled'
};

var stringArray = function stringArray(arr) {
    return !arr || !arr.length ? undefined : arr.join(',');
};

var parseSuccess = function parseSuccess(response) {
    if (response.data) {
        return _q2.default.resolve(response.data);
    } else {
        return _q2.default.reject({
            type: 'https://analytics.wixrestaurants.com/errors/protocol',
            title: 'Protocol error.',
            detail: 'Successful response was empty.'
        });
    }
};

var parseError = function parseError(error) {
    if (error.response && error.response.data) {
        return _q2.default.reject(error.response.data);
    } else {
        switch (error.code) {
            case 'ECONNABORTED':
                return _q2.default.reject({
                    type: 'https://analytics.wixrestaurants.com/errors/timeout',
                    title: 'Request timed out.'
                });
            case 'ENOTFOUND': // fall through
            default:
                return _q2.default.reject({
                    type: 'https://analytics.wixrestaurants.com/errors/network',
                    title: 'Network is down.'
                });
        }
    }
};

var WixRestaurantsAnalyticsClient = function () {
    function WixRestaurantsAnalyticsClient() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$baseUrl = _ref.baseUrl,
            baseUrl = _ref$baseUrl === undefined ? BaseUrls.production : _ref$baseUrl,
            _ref$timeout = _ref.timeout,
            timeout = _ref$timeout === undefined ? 0 : _ref$timeout;

        _classCallCheck(this, WixRestaurantsAnalyticsClient);

        this._axios = _axios2.default.create({
            baseURL: baseUrl,
            timeout: timeout
        });
    }

    _createClass(WixRestaurantsAnalyticsClient, [{
        key: 'restaurantOrderStats',
        value: function restaurantOrderStats(_ref2) {
            var accessToken = _ref2.accessToken,
                restaurantId = _ref2.restaurantId,
                metric = _ref2.metric,
                groupBy = _ref2.groupBy,
                timezone = _ref2.timezone,
                since = _ref2.since,
                until = _ref2.until,
                statuses = _ref2.statuses,
                platforms = _ref2.platforms;

            var statusesStr = stringArray(statuses);
            var platformsStr = stringArray(platforms);

            return this._request({
                resource: '/restaurants/' + restaurantId + '/orders/stats',
                params: Object.assign({}, {
                    metric: metric,
                    group_by: groupBy,
                    time_zone: timezone,
                    since: since,
                    until: until
                }, statusesStr ? { statuses: statusesStr } : {}, platformsStr ? { platforms: platformsStr } : {}),
                accessToken: accessToken
            }).then(function (value) {
                return value.stats;
            });
        }
    }, {
        key: 'chainOrderStats',
        value: function chainOrderStats(_ref3) {
            var accessToken = _ref3.accessToken,
                chainId = _ref3.chainId,
                metric = _ref3.metric,
                groupBy = _ref3.groupBy,
                timezone = _ref3.timezone,
                since = _ref3.since,
                until = _ref3.until,
                statuses = _ref3.statuses,
                platforms = _ref3.platforms;

            var statusesStr = stringArray(statuses);
            var platformsStr = stringArray(platforms);

            return this._request({
                resource: '/chains/' + chainId + '/orders/stats',
                params: Object.assign({}, {
                    metric: metric,
                    group_by: groupBy,
                    time_zone: timezone,
                    since: since,
                    until: until
                }, statusesStr ? { statuses: statusesStr } : {}, platformsStr ? { platforms: platformsStr } : {}),
                accessToken: accessToken
            }).then(function (value) {
                return value.stats;
            });
        }
    }, {
        key: '_request',
        value: function _request(_ref4) {
            var resource = _ref4.resource,
                params = _ref4.params,
                accessToken = _ref4.accessToken;

            return this._axios.get(resource, {
                params: params,
                headers: {
                    Authorization: 'Bearer ' + accessToken
                }
            }).then(parseSuccess, parseError);
        }
    }]);

    return WixRestaurantsAnalyticsClient;
}();

exports.default = WixRestaurantsAnalyticsClient;


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-restaurants-js-sdk/dist/clients/WixRestaurantsAnalyticsClient.js
// module id = 735
// module chunks = 0